/* tslint:disable */
/* eslint-disable */
/**
 * Dialpad Contact API
 * API to fetch call center groups with specific filters.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface GroupDetails
 */
export interface GroupDetails {
  /**
   *
   * @type {Array<string>}
   * @memberof GroupDetails
   */
  access: Array<string>;
  /**
   *
   * @type {string}
   * @memberof GroupDetails
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GroupDetails
   */
  type: string;
}

/**
 * Check if a given object implements the GroupDetails interface.
 */
export function instanceOfGroupDetails(value: object): value is GroupDetails {
  if (!('access' in value) || value['access'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function GroupDetailsFromJSON(json: any): GroupDetails {
  return GroupDetailsFromJSONTyped(json, false);
}

export function GroupDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GroupDetails {
  if (json == null) {
    return json;
  }
  return {
    access: json['access'],
    id: json['id'],
    type: json['type'],
  };
}

export function GroupDetailsToJSON(value?: GroupDetails | null): any {
  if (value == null) {
    return value;
  }
  return {
    access: value['access'],
    id: value['id'],
    type: value['type'],
  };
}
